import { Inject, Injectable } from '@angular/core';
import { remove } from 'osn-shared';
import { fromEvent, take } from 'rxjs';
import { Config } from '../../config';
import { CONFIG_TOKEN } from 'config-token';

interface FileUploadTarget {
  onFileInputChange(event: Event);
}

@Injectable({ providedIn: 'root' })
export class GlobalFileUploadService {
  public globalFileUploadEnabled = this.config.isMassImgUploadEnabled;

  private readonly fileUploadTargets: FileUploadTarget[] = [];

  constructor(@Inject(CONFIG_TOKEN) private readonly config: Config) {}

  public uploadFileIntoAvailableTargets() {
    const inputElement = document.createElement('input');

    inputElement.style.top = '0';
    inputElement.style.bottom = '0';
    inputElement.style.width = '0';
    inputElement.style.height = '0';
    inputElement.style.position = 'fixed';
    inputElement.style.visibility = 'hidden';
    inputElement.type = 'file';
    inputElement.accept = '.png, .jpg, .jpeg';

    document.body.appendChild(inputElement);

    fromEvent(inputElement, 'change')
      .pipe(take(1))
      .subscribe((event) => {
        this.fileUploadTargets.forEach((it) => it.onFileInputChange(event));
        document.body.removeChild(inputElement);
      });

    inputElement.click();
  }

  public registerFileUploadComponent(component: FileUploadTarget) {
    this.fileUploadTargets.push(component);
  }

  public unregisterFileUploadComponent(component: FileUploadTarget) {
    remove(this.fileUploadTargets, component);
  }
}
